import type { IconProps } from 'common-types';
import { Else, If, Then } from 'react-if';

export const Trash = ({
  width = 24,
  height = 24,
  fill,
  isLine = true,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <If condition={isLine}>
      <Then>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 6.5V6C8.00342 5.33801 8.2679 4.70411 8.73601 4.23601C9.20411 3.7679 9.83801 3.50342 10.5 3.5H13.5C14.162 3.50342 14.7959 3.7679 15.264 4.23601C15.7321 4.70411 15.9966 5.33801 16 6V6.5H18.75C19.0152 6.5 19.2696 6.60536 19.4571 6.79289C19.6446 6.98043 19.75 7.23478 19.75 7.5C19.75 7.76522 19.6446 8.01957 19.4571 8.20711C19.2696 8.39464 19.0152 8.5 18.75 8.5H18.25V18C18.2466 18.662 17.9821 19.2959 17.514 19.764C17.0459 20.2321 16.412 20.4966 15.75 20.5H8.25C7.58801 20.4966 6.95411 20.2321 6.48601 19.764C6.0179 19.2959 5.75342 18.662 5.75 18V8.5H5.25C4.98478 8.5 4.73043 8.39464 4.54289 8.20711C4.35536 8.01957 4.25 7.76522 4.25 7.5C4.25 7.23478 4.35536 6.98043 4.54289 6.79289C4.73043 6.60536 4.98478 6.5 5.25 6.5H8ZM7.75 8.5V18C7.75 18.1326 7.80268 18.2598 7.89645 18.3536C7.99021 18.4473 8.11739 18.5 8.25 18.5H15.75C15.8826 18.5 16.0098 18.4473 16.1036 18.3536C16.1973 18.2598 16.25 18.1326 16.25 18V8.5H7.75ZM14 6.5V6C14 5.86739 13.9473 5.74021 13.8536 5.64645C13.7598 5.55268 13.6326 5.5 13.5 5.5H10.5C10.3674 5.5 10.2402 5.55268 10.1464 5.64645C10.0527 5.74021 10 5.86739 10 6V6.5H14Z"
          fill={fill ?? '#14171A'}
        />
      </Then>
      <Else>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 6.5V6C8.00342 5.33801 8.2679 4.70411 8.73601 4.23601C9.20411 3.7679 9.83801 3.50342 10.5 3.5H13.5C14.162 3.50342 14.7959 3.7679 15.264 4.23601C15.7321 4.70411 15.9966 5.33801 16 6V6.5H18.75C19.0152 6.5 19.2696 6.60536 19.4571 6.79289C19.6446 6.98043 19.75 7.23478 19.75 7.5C19.75 7.76522 19.6446 8.01957 19.4571 8.20711C19.2696 8.39464 19.0152 8.5 18.75 8.5H18.25V18C18.2466 18.662 17.9821 19.2959 17.514 19.764C17.0459 20.2321 16.412 20.4966 15.75 20.5H8.25C7.58801 20.4966 6.95411 20.2321 6.48601 19.764C6.0179 19.2959 5.75342 18.662 5.75 18V8.5H5.25C4.98478 8.5 4.73043 8.39464 4.54289 8.20711C4.35536 8.01957 4.25 7.76522 4.25 7.5C4.25 7.23478 4.35536 6.98043 4.54289 6.79289C4.73043 6.60536 4.98478 6.5 5.25 6.5H8ZM14 6.5V6C14 5.86739 13.9473 5.74021 13.8536 5.64645C13.7598 5.55268 13.6326 5.5 13.5 5.5H10.5C10.3674 5.5 10.2402 5.55268 10.1464 5.64645C10.0527 5.74021 10 5.86739 10 6V6.5H14Z"
          fill={fill ?? '#14171A'}
        />
      </Else>
    </If>
  </svg>
);
